import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import PictogramDto from '../dto/PictogramDto';

class PictogramTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'pictogramTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<PictogramDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, PictogramDto)))
				.catch(reject);
		});
	}
}

export default new PictogramTableService();
